import {
  QuestionCreationTaskInformation,
  QuestionCreationTaskQuestionDetails,
} from '@exam-management/question-creation-task-details';
import { Box, Flex } from '@shared/components';

export default function QuestionCreationTaskDetailsPage() {
  return (
    <Box sx={{ padding: (theme) => theme.spacing(6) }}>
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(6),
        })}
      >
        <QuestionCreationTaskInformation />
        <QuestionCreationTaskQuestionDetails />
      </Flex>
    </Box>
  );
}
